export const API_SUCCESS_MESSAGES = {
  EDIT_DEVICE: 'Recorder has been updated!',
  DELETE_DEVICE: (value) => `${value} has been deleted!`,
}
